/*
* Sortable table events
* Version : 1.0.0
*
* */

ckdc.ready(function ($) {

  if (typeof ckdc == 'undefined') {
    return;
  }

  ckdc.setup.addSetupContent('table-sortable', setupContent);

  /*
  * Find table markup and make them sortable
  *
  * @param content HTML content
  * @since   1.0.0
  */

  function setupContent(content) {
    var tables = content.find("table.dd-table-sort[id], .dd-table-sortable table");
    if (tables.length > 0) {
      tables.each(function () {
        $(this).tableSortable();
      });
    }
  }
});
